module.exports = __webpack_public_path__ + "img/111f9fe.png";